import { makeStyles } from "@material-ui/core"

const styles = makeStyles((theme) => ({
  container: {
    maxHeight: "calc(100% - 70px)",
  },
  cardBox: {
    paddingRight: theme.spacing(2),
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
  },
  dataWrapper: {
    [theme.breakpoints.down("sm")]: {
      width: "90%",
    },
  },
}))

export default styles
